import { dapvApi } from 'services/providers/dapv';
import { ApiResponse } from 'services/providers/dapv.types';
import { DeleteDocumentPayload, UpdateEventDocumentPayload, UpdateEventDocumentResponse } from './document.types';

export const documentApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        updateEventDocument: build.mutation<UpdateEventDocumentResponse, UpdateEventDocumentPayload>({
            query: ({ project_id, event_id, document_id, ...body }) => ({
                url: `/app/projects/${project_id}/events/${event_id}/documents/${document_id}`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: ApiResponse<UpdateEventDocumentResponse>) => response.data
        }),

        deleteProfileDocument: build.mutation<ApiResponse<null>, DeleteDocumentPayload>({
            query: ({ personId, docId }: DeleteDocumentPayload) => {
                return {
                    url: `/app/persons/${personId}/documents/${docId}`,
                    method: 'DELETE',
                };
            },
            transformResponse: (response: ApiResponse<null>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
    })
});

export const { useUpdateEventDocumentMutation, useDeleteProfileDocumentMutation } = documentApi;
